export const INSURANCES_BASE_KEY = 'insurances';
export const INSURED_PARTICIPANTS_BASE_KEY = 'insured-participants';
export const CLIENTS_WITH_INSURANCE_BASE_KEY = 'clients-with-insurance';

export const insurancesApiQueryKeys = {
  all: () => [INSURANCES_BASE_KEY] as const,
  list: () => [INSURANCES_BASE_KEY, 'list'] as const,
  byId: (id: string) => [INSURANCES_BASE_KEY, id] as const,
};

export const insuredParticipantsApiQueryKeys = {
  all: () => [INSURED_PARTICIPANTS_BASE_KEY] as const,
  byClient: (clientId: string) =>
    ['clients', clientId, INSURED_PARTICIPANTS_BASE_KEY] as const,
};

export const clientsWithInsuranceApiQueryKeys = {
  all: () => [CLIENTS_WITH_INSURANCE_BASE_KEY] as const,
};
